import { HttpClient } from '@angular/common/http';
import { NgxPermissionsService } from 'ngx-permissions';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppConfig, ACCESS_KEYS } from './app.config';

import { assetUrl } from './asset-url';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http, assetUrl('i18n/'), '.json');
}

export function appConfigProviderFactory(
	provider: AppConfig,
	ps: NgxPermissionsService
): any {
	return function(): Promise<any> {
		const accessKeys: string | null = localStorage.getItem(ACCESS_KEYS);
		if (accessKeys) {
			try {
				const array: string[] = JSON.parse(accessKeys);
				if (Array.isArray(array)) {
					ps.loadPermissions(array);
				}
			} catch (e) {
				localStorage.setItem(ACCESS_KEYS, JSON.stringify([]));
			}
		}
		return provider.load();
	};
}
